import React from "react";
import './styles.scss'

const ImageGroup = ({title = '', xs}) =>
{
   return (
      <div className="demo-avatar-group my-auto float-right">
         <div className={`main-img-user ${xs && 'avatar-xs'}`}>
            <img alt="avatar" className="rounded-circle"
                 src="https://www.spruko.com/demo/spruha/spruha/assets/img/users/5.jpg"/>
         </div>
         <div className={`main-img-user ${xs && 'avatar-xs'}`}>
            <img alt="avatar" className="rounded-circle"
                 src="https://www.spruko.com/demo/spruha/spruha/assets/img/users/5.jpg"/>
         </div>
         <div className={`main-img-user ${xs && 'avatar-xs'}`}>
            <img alt="avatar" className="rounded-circle"
                 src="https://www.spruko.com/demo/spruha/spruha/assets/img/users/5.jpg"/>
         </div>
         <div className={`main-img-user ${xs && 'avatar-xs'}`}>
            <img alt="avatar" className="rounded-circle"
                 src="https://www.spruko.com/demo/spruha/spruha/assets/img/users/5.jpg"/>
         </div>
         <div className="">{title}</div>
      </div>
   )
}
export default ImageGroup;
